import { parseNumberToCurrencyFormat } from '../../../helpers/parseCurrencyFormat';

export const getMixedChartOptions = ({ series, labels, formatToGBP = true }) => ({
  chart: {
    height: 380,
    type: 'line',
    stacked: false,
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    width: [0, 3],
    color: 'red',
  },
  series,
  xaxis: {
    categories: labels,
  },
  colors: ['#1c84c6', '#ed5565'],
  yaxis: [
    {
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: 'green',
      },
      title: {
        text: 'Sales',
        style: {
          fontSize: '14px',
          fontWeight: 500,
        },
      },
      labels: {
        formatter(value) {
          if (!formatToGBP || typeof value !== 'number') return value;
          return parseNumberToCurrencyFormat(value);
        },
      },
    },
  ],
  tooltip: {
    followCursor: true,
    y: {
      formatter(y) {
        if (typeof y !== 'undefined' && formatToGBP) {
          return parseNumberToCurrencyFormat(y);
        }
        return y;
      },
    },
  },
  grid: {
    borderColor: 'black',
    padding: {
      right: 20,
      bottom: 0,
    },
  },
  legend: {
    offsetY: 5,
  },
  responsive: [
    {
      breakpoint: 600,
      options: {
        yaxis: {
          show: false,
        },
        legend: {
          show: false,
        },
      },
    },
  ],
});
